<template>
  <div class="xb-select-order">
    <div class="title">选品单</div>
    <div class="screen">
      <div class="screen-button"></div>
      <div class="screen-search">
        <div class="search">
          <el-select v-model="form.status" clearable placeholder="选品单状态">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input placeholder="商品名称/选品单号" clearable v-model="form.codeName"></el-input>
          <el-button class="btn-red" @click="search">筛选</el-button>
        </div>
      </div>
    </div>
    <ul class="table-header">
      <li class="detail">订单详情</li>
      <li class="commission">抽佣比例/金额</li>
      <li class="price">预计直播时间</li>
      <li class="state">订单状态</li>
      <li class="operation">操作</li>
    </ul>
    <div class="table" v-for="(value,index) in tableData" :key="index">
      <div class="table-title">
        <p class="time">{{ value.time }}</p>
        <p class="number">
          <span>订单编号：</span>
          <span class="num">{{ value.code }}</span>
        </p>
      </div>
      <div class="table-body">
        <div class="table-detail">
          <div class="detail-child" v-for=" (v,i) in value.items" :key="i">
            <img v-if="v.img" :src="v.img" alt @click="goToProduct(v.id)" />
            <img
              v-else
              src="http://image.8844it.com/ydb2/goodDefault.png"
              alt
              @click="goToProduct(v.id)"
            />
            <div class="name-specifications">
              <p class="name" :title="v.name" @click="goToProduct(v.id)">{{ v.name }}</p>
              <p class="specifications" :title="v.specifications">{{ v.specifications }}</p>
            </div>
            <p class="price">
              <span>￥{{ v.price }}</span>
            </p>
            <p class="commission-rate">
              <span>×{{ v.quantity }}</span>
            </p>
          </div>
        </div>
        <div class="table-commission">
          <div class="commission-price" v-for=" (v,i) in value.items" :key="i">
            <span>{{ v.commissionRate }}%</span>
            <span>/{{ v.commissionPrice }}</span>
          </div>
        </div>
        <div class="table-price">
          <span>{{value.liveTime}}</span>
        </div>
        <div class="table-state">
          <span>{{value.statusName}}</span>
        </div>
        <div class="table-operation">
          <el-button class="color" v-if="value.status===1" @click="cancelSelection(value.id)">取消</el-button>
          <el-button class="color" v-if="value.status===3" @click="confirmInvitation(value.id)">确认邀约</el-button>
          <el-button
            class="color"
            v-if="value.status===3||value.status===4||value.status===5"
            @click="openInvitationDialogVisible(value)"
          >查看邀约</el-button>
          <el-button
            class="color"
            v-if="value.status===5"
            @click="openLiveTimeDialogVisible(value.id)"
          >直播完成</el-button>
        </div>
      </div>
    </div>
    <div class="no-order" v-if="tableData.length === 0">暂无数据</div>
    <div class="table_pagination">
      <pagination-modul @queryChange="updatePage" :currentPage="page" :total="total"></pagination-modul>
    </div>
    <el-dialog
      class="el-dialog-component"
      title="查看邀约"
      :visible.sync="invitationDialogVisible"
      width="420px"
      top="25vh"
    >
      <div class="border"></div>
      <el-form class="invitation-form" ref="form" :model="invitationForm" label-width="100px">
        <el-form-item label="寄样：">
          <span v-if="invitationForm.isSend===1">是</span>
          <span v-else>否</span>
        </el-form-item>
        <el-form-item label="回寄：">
          <span v-if="invitationForm.isReturn===1">是</span>
          <span v-else>否</span>
        </el-form-item>
        <el-form-item label="产品说明：">
          <a :href="invitationForm.message">
            <el-button class="color">点击下载</el-button>
          </a>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="color" @click="invitationDialogVisible=false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="el-dialog-component"
      title="直播完成"
      :visible.sync="liveTimeDialogVisible"
      width="420px"
      top="25vh"
    >
      <div class="border"></div>
      <el-form class="liveTime-form" ref="form" :model="liveTimeForm" label-width="100px">
        <el-form-item label="直播日期：">
          <el-date-picker
            v-model="liveTimeForm.date"
            class="white"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="直播时间：">
          <div class="time-picker">
            <el-time-picker
              class="white"
              value-format="HH:mm:ss"
              v-model="liveTimeForm.startTime"
              placeholder="请选择"
              :picker-options="{
        selectableRange:`00:00:00 -${liveTimeForm.endTime ? liveTimeForm.endTime : '23:59:00'}`
    }"
            ></el-time-picker>
            <span>&nbsp;至&nbsp;</span>
            <el-time-picker
              class="white"
              value-format="HH:mm:ss"
              v-model="liveTimeForm.endTime"
              placeholder="请选择"
              :picker-options="{
        selectableRange:`${liveTimeForm.startTime ? liveTimeForm.startTime +':00' : '00:00:00'}-23:59:00`
    }"
            ></el-time-picker>
          </div>
        </el-form-item>
        <el-form-item label="图片说明：">
          <el-upload
            :class="liveTimeForm.fileList.length===0?'upload-img':'upload-img none'"
            action="#"
            list-type="picture-card"
            :auto-upload="true"
            :limit="1"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :file-list="liveTimeForm.fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <p class="img-size">仅限jpg、jpeg、png格式图片大小不超过5M</p>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="white-color" @click="liveTimeDialogVisible=false">取消</el-button>
        <el-button class="color" @click="confirmLiveTime">确定</el-button>
      </div>
    </el-dialog>
    <!-- 取消订单弹框 -->
    <Dialog
      :title="title"
      :content="content"
      :dialogVisible="showCancelOrderDialog"
      @confirm="cancelOrder"
      @cancel="notCancelOrder"
      @hide="toHideCancelOrderDialog"
    ></Dialog>
  </div>
</template>

<script>
import Dialog from "base/xb-base/Dialog";
import PaginationModul from "base/PaginationTpl";
import XBOrderReturn from "models/xb/orderReturn.js";
import XBSelectionCart from "models/xb/selection-cart.js";
import ImgUploader from "models/img-upload.js";
const xbOrderReturn = new XBOrderReturn();
const xbSelectionCart = new XBSelectionCart();
const imgUploader = new ImgUploader();
export default {
  components: {
    PaginationModul,
    Dialog,
  },
  data() {
    return {
      // 是否显示取消订单、确定邀约操作弹框
      showCancelOrderDialog: false,
      title: "取消订单",
      content: "是否取消订单",
      type: 1, //1为取消订单，2为确定邀约
      // 弹框时被选中的orderCode
      id: "",
      form: {
        status: "",
        codeName: "",
      },
      formSearch: {
        status: "",
        codeName: "",
      },
      status: [
        {
          value: 0,
          label: "拒绝",
        },
        {
          value: 1,
          label: "待审核",
        },
        {
          value: 2,
          label: "待邀约",
        },
        {
          value: 3,
          label: "待确认邀约",
        },
        {
          value: 4,
          label: "待完成",
        },
        {
          value: 5,
          label: "邀约完成",
        },
        {
          value: 6,
          label: "已取消",
        },
        {
          value: 7,
          label: "待直播确认",
        },
        {
          value: 8,
          label: "完成",
        },
      ],
      tableData: [],
      total: 0, // 数据总数量
      page: 1,
      //查看邀约
      invitationDialogVisible: false, // 是否显示弹框
      invitationForm: {
        isSend: "",
        isReturn: "",
        message: "",
      },
      //直播完成
      liveTimeDialogVisible: false,
      liveTimeForm: {
        id: "",
        date: "",
        startTime: "",
        endTime: "",
        fileList: [],
      },
    };
  },
  created() {
    this.getData();
  },
  watch: {
    time: {
      handler(newVal) {
        this.liveTimeForm.time = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 获取所有数据
    getData() {
      let status = this.formSearch.status;
      let searchValue = this.formSearch.codeName;
      let currentPage = this.page;
      xbSelectionCart
        .getXBSelectionOrderList(status, searchValue, currentPage)
        .then((res) => {
          if (res.success) {
            this.total = res.result.totalNum;
            let arr = [];
            res.result.items.map((value) => {
              let obj = {};
              obj.id = value.id;
              obj.time = this.fmtDate(value.createTime);
              obj.liveTime = this.fmtDate(value.liveTime);
              obj.code = value.code;
              obj.isReturn = value.isReturn;
              obj.isSend = value.isSend;
              obj.message = value.message;
              obj.statusName = this.getCodeName(value.status);
              obj.status = value.status;
              obj.items = [];
              value.selectionDetailList.map((v) => {
                let object = {};
                object.id = v.goodsId;
                object.img = v.goodsPic;
                object.name = v.goodsName;
                object.price = v.price;
                object.quantity = v.quantity;
                object.commissionRate = v.commissionRate * 100;
                object.commissionPrice = (v.commissionRate * v.price).toFixed(
                  2
                );
                let itemTitle = JSON.parse(v.itemTitle);
                let specifications = "";
                for (let key in itemTitle) {
                  specifications += `,${itemTitle[key]}`;
                }
                object.specifications = specifications.substring(1);
                obj.items.push(object);
              });
              arr.push(obj);
            });
            this.tableData = arr;
          }
        });
    },
    // 根据订单状态返回对应的值
    getCodeName(status) {
      let statusName = [
        "拒绝",
        "待审核",
        "待邀约",
        "待确认邀约",
        "待完成",
        "邀约完成",
        "已取消",
        "待直播确认",
        "完成",
      ];
      return statusName[status];
    },
    // 点击搜索按钮
    search() {
      this.page = 1;
      this.formSearch = this.form;
      this.getData();
    },
    //点击取消按钮
    cancelSelection(id) {
      this.id = id;
      this.title = "取消订单";
      this.content = "是否取消订单";
      this.type = 1;
      this.showCancelOrderDialog = true;
    },
    // 隐藏编辑框
    toHideCancelOrderDialog() {
      this.showCancelOrderDialog = false;
    },
    // 不取消订单
    notCancelOrder() {
      this.showCancelOrderDialog = false;
    },
    //取消订单或确定邀约
    cancelOrder() {
      let data = {
        id: this.id,
      };
      if (this.type === 1) {
        xbSelectionCart.postXBCancelSelection(data).then((res) => {
          if (res.success) {
            this.showCancelOrderDialog = false;
            this.getData();
          }
        });
      } else if (this.type === 2) {
        xbSelectionCart.postXBConfirmInvitation(data).then((res) => {
          if (res.success) {
            this.showCancelOrderDialog = false;
            this.getData();
          }
        });
      }
    },
    //确定邀约
    confirmInvitation(id) {
      this.id = id;
      this.title = "确定邀约";
      this.content = "是否确定邀约";
      this.type = 2;
      this.showCancelOrderDialog = true;
    },
    //查看邀约弹窗
    openInvitationDialogVisible(value) {
      this.invitationDialogVisible = true;
      this.invitationForm.isSend = value.isSend;
      this.invitationForm.isReturn = value.isReturn;
      this.invitationForm.message = value.message;
    },
    //直播完成弹窗
    openLiveTimeDialogVisible(id) {
      this.liveTimeForm = {
        id: id,
        date: "",
        time: [],
        fileList: [],
      };
      this.time = [new Date(), new Date()];
      this.liveTimeDialogVisible = true;
    },
    //直播完成上传
    confirmLiveTime() {
      console.log(this.liveTimeForm.startTime);
      if (!this.liveTimeForm.date) {
        this.$message.error("请选择直播日期");
        return false;
      }
      if (!this.liveTimeForm.startTime || !this.liveTimeForm.endTime) {
        this.$message.error("请选择直播时间");
        return false;
      }
      if (this.liveTimeForm.fileList.length === 0) {
        this.$message.error("请上传图片");
        return false;
      }
      let data = {};
      data.id = this.liveTimeForm.id;
      data.realStartTime =
        this.liveTimeForm.date + " " + this.liveTimeForm.startTime;
      data.realEndTime =
        this.liveTimeForm.date + " " + this.liveTimeForm.endTime;
      data.livePic = this.liveTimeForm.fileList[0].url;
      xbSelectionCart.postXBFinishLive(data).then((res) => {
        if (res.success) {
          this.liveTimeDialogVisible = false;
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        // this.fileList = this.fileList.splice(1, )
        return false;
      } else {
        imgUploader
          .postImgUpload(file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.liveTimeForm.fileList.push(obj);
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
        // console.log(file);
      }
    },
    handleRemove(file, fileList) {
      this.liveTimeForm.fileList = [];
    },
    // 时间格式转换
    fmtDate(date) {
      let dateFn = new Date(date);
      let yy = dateFn.getFullYear();
      let mm = dateFn.getMonth() + 1;
      let dd = dateFn.getDate();
      let hh =
        dateFn.getHours() < 10
          ? "0" + dateFn.getHours()
          : "" + dateFn.getHours();
      let xx =
        dateFn.getMinutes() < 10
          ? "0" + dateFn.getMinutes()
          : "" + dateFn.getMinutes();
      let ss =
        dateFn.getSeconds() < 10
          ? "0" + dateFn.getSeconds()
          : "" + dateFn.getSeconds();
      let time = yy + "-" + mm + "-" + dd + " " + hh + ":" + xx + ":" + ss;
      return time;
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.postGoods();
    },
    // 前往商品详情页
    goToProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
.xb-select-order {
  background: #fff;
  padding: 0 20px;
  color: #606266;
  padding-bottom: 20px;
  min-height: 440px;
  box-sizing: border-box;
  .title {
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 16px;
    color: rgba(96, 98, 102, 1);
    letter-spacing: 1px;
    border-bottom: 1px solid #e4e4e4;
  }
  .screen {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .screen-button {
      .el-button {
        color: #606266;
        font-size: 14px;
      }
      .active {
        color: #df3445;
      }
    }
    .screen-search {
      display: flex;
      .search {
        display: flex;
      }
    }
  }
  .table-header {
    display: flex;
    height: 32px;
    background: rgba(247, 247, 247, 1);
    margin-bottom: 16px;
    font-size: 12px;
    color: #606266;
    letter-spacing: 1px;
    .detail {
      flex: 1;
      padding-left: 160px;
      line-height: 32px;
    }
    .commission,
    .price,
    .state,
    .operation {
      width: 150px;
      line-height: 32px;
      text-align: center;
    }
  }
  .table {
    margin-bottom: 20px;
    letter-spacing: 1px;
    .table-title {
      height: 32px;
      background: rgba(247, 247, 247, 1);
      display: flex;
      align-items: center;
      font-size: 12px;
      padding: 0 20px;
      color: #919398;
      box-sizing: border-box;
      border: 1px solid rgba(228, 228, 228, 1);
      .time {
        font-size: 12px;
        margin-right: 24px;
      }
      .num {
        color: #606266;
      }
    }
    .table-body {
      box-sizing: border-box;
      display: flex;
      .table-detail {
        flex: 1;
        box-sizing: border-box;
        border: 1px solid rgba(228, 228, 228, 1);
        border-top: 0;
        .detail-child {
          height: 80px;
          display: flex;
          padding-left: 20px;
          align-items: center;
          img {
            width: 60px;
            height: 60px;
            cursor: pointer;
          }
          .name-specifications {
            margin-left: 8px;
            margin-right: 10px;
            .name {
              width: 180px;
              font-size: 12px;
              height: 32px;
              line-height: 16px;
              margin-bottom: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              letter-spacing: 1px;
              cursor: pointer;
            }
            .name:hover {
              color: rgba(223, 52, 69, 1);
            }
            .specifications {
              font-size: 12px;
              word-break: break-all;
              width: 120px;
              color: #999;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
          .price {
            font-size: 12px;
            width: 60px;
          }
          .commission-rate {
            font-size: 12px;
          }
        }
      }
      .table-price,
      .table-state,
      .table-operation {
        min-width: 150px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(228, 228, 228, 1);
        border-right: 1px solid rgba(228, 228, 228, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }
      .table-commission {
        min-width: 150px;
        border-bottom: 1px solid rgba(228, 228, 228, 1);
        border-right: 1px solid rgba(228, 228, 228, 1);
        font-size: 12px;
        .commission-price {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .table-operation {
        flex-direction: column;
        .el-button {
          margin: 5px 0;
          width: 64px;
          height: 20px;
          font-size: 12px;
        }
        .color {
          background: rgba(223, 52, 69, 0.7);
          border-radius: 2px;
          color: #fff;
          border: 0px;
          padding: 0;
        }
        .color:hover {
          background: rgba(223, 52, 69, 1);
        }
      }
    }
  }
  .no-order {
    border: 1px solid #e4e4e4;
    height: 80px;
    text-align: center;
    line-height: 80px;
    font-size: 12px;
    color: #909399;
  }
  .table_pagination {
    display: flex;
    justify-content: flex-end;
  }
  .el-dialog {
    .el-button {
      margin: 0 10px;
      width: 64px;
      height: 24px;
      font-size: 12px;
    }
    .color {
      background: rgba(223, 52, 69, 0.7);
      border-radius: 2px;
      color: #fff;
      border: 0px;
      padding: 0;
    }
    .color:hover {
      background: rgba(223, 52, 69, 1);
    }
    .white-color {
      background: #fff;
      border-radius: 2px;
      color: rgba(223, 51, 69, 1);
      border: 1px solid rgba(223, 51, 69, 1);
      padding: 0;
    }
    .liveTime-form {
      padding-top: 16px;
      .img-size {
        font-size: 12px;
        color: rgba(201, 201, 201, 1);
        line-height: 18px;
      }
    }
    .dialog-footer {
      height: 60px;
      border-top: 1px solid #ededed;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
<style lang="scss">
.xb-select-order {
  .screen-search {
    .search {
      > .el-select {
        min-width: 120px;
        max-width: 120px;
        margin-right: 20px;
        .el-input__inner {
          height: 32px;
          background: rgba(234, 238, 245, 0.2);
          border-radius: 4px;
          border: 1px solid rgba(234, 238, 245, 1);
          padding: 0 20px 0 8px;
          font-size: 14px;
          font-family: "PingFangSC-Regular";
          color: rgba(96, 98, 102, 1);
          letter-spacing: 1px;
          padding-left: 15px;
        }
        .el-input__suffix {
          height: 40px;
          top: -3px;
          right: 0px;
        }
        .is-focus {
          .el-input__inner {
            border: 1px solid rgba(61, 116, 242, 1);
          }
        }
      }
      > .el-input {
        width: 220px;
        .el-input__inner {
          height: 32px;
          background: rgba(234, 238, 245, 0.2);
          border-radius: 4px;
          border: 1px solid rgba(234, 238, 245, 1);
        }
        .el-input__inner:hover {
          border-color: rgba(192, 196, 204, 1);
        }
        .el-input__inner:focus {
          border-color: rgba(61, 116, 242, 1);
        }
        .el-input__suffix {
          height: 40px;
          top: -3px;
          right: 0px;
          cursor: pointer;
        }
      }
      .btn-red {
        height: 32px;
        width: 80px;
        color: #fff;
        margin-left: 20px;
        border: 0px;
        background: rgba(223, 52, 69, 0.75);
        &:hover {
          background: rgba(223, 52, 69, 1);
        }
      }
    }
  }
  .el-dialog {
    .el-input__prefix {
      height: 40px;
      top: -3px;
      cursor: pointer;
    }
    .el-date-editor {
      width: 262px;
    }
    .time-picker {
      display: flex;
      .el-date-editor {
        width: 120px;
        height: 32px;
        padding: 0;
        .el-range-input {
          padding-top: 2px;
          height: 28px;
        }
      }
    }
    .upload-img {
      display: flex;
      .el-upload-list--picture-card {
        height: 50px;
      }
      .el-upload--picture-card {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-upload-list--picture-card .el-upload-list__item {
        width: 50px;
        height: 50px;
      }
    }
    .none {
      .el-upload--picture-card {
        display: none;
      }
    }
  }
}
</style>
